import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=7533377d&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=ts&"
export * from "./FullScreen.vue?vue&type=script&lang=ts&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=7533377d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7533377d",
  null
  
)

export default component.exports